import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./InputGroup.css";

export default function InputGroup(props) {
  return (
    <div className={classNames(styles.root, props.className)}>
      <h3 className={styles.groupHeader}>{props.headerText}</h3>
      {props.inputs.map((input, key) => (
        <div key={key} className={styles.field}>
          {input}
        </div>
      ))}
    </div>
  );
}

InputGroup.propTypes = {
  className: PropTypes.string,
  headerText: PropTypes.string.isRequired,
  inputs: PropTypes.arrayOf(PropTypes.node).isRequired,
};
